import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { EnumDepositOption, VehicleService } from 'api';
import { getAgreementsRequestIdState } from 'api/agreements/getAgreementsAndVehicle';
import { getObeDetailsRequestIdState } from 'api/obes/getObeDetails';
import { getCustomerVehiclesRequestIdState } from 'api/vehicles/getCustomerVehicles';
import { isVehicleAlreadyRegisteredRequestId as isVehicleAlreadyRegisteredRequestIdAtom } from 'api/vehicles/isVehicleAlreadyRegistered';
import tagOptions from 'constants/tagOptions';
import { RECENTLY_REPLACED } from 'constants/text';
import { UNREGISTER_VEHICLE_SUMMARY } from 'routes/overview/UnregisterTag/paths';
export default function useUnregisterVehicles() {
  const {
    push
  } = useHistory();
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [requestId, setRequestId] = useRecoilState(getAgreementsRequestIdState);
  const [vehicleRequestId, setVehicleRequestId] = useRecoilState(getCustomerVehiclesRequestIdState);
  const setObeDetailsRequestState = useSetRecoilState(getObeDetailsRequestIdState);
  const setIsVehicleAlreadyRegisteredRequestId = useSetRecoilState(isVehicleAlreadyRegisteredRequestIdAtom);
  const unregisterVehiclesFunction = async elements => {
    const vehicles = elements.map(element => ({
      vehicleId: element.id,
      reuseOBE: element.tagOption === tagOptions.KEEP_AND_REUSE,
      depositOption: EnumDepositOption.AwaitReturn,
      markAsReturned: false
    }));
    try {
      setIsLoading(true);
      await VehicleService.unregisterVehicles({
        body: {
          vehicles
        }
      });
      setRequestId(requestId + 1);
      setVehicleRequestId(vehicleRequestId + 1);
      setObeDetailsRequestState(prev => prev + 1);
      setIsVehicleAlreadyRegisteredRequestId(prev => prev + 1);
      push(UNREGISTER_VEHICLE_SUMMARY, {
        tagOption: elements[0]?.tagOption
      });
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.data.includes(RECENTLY_REPLACED)) {
        enqueueSnackbar(t('error.recently_replaced'), {
          variant: 'error'
        });
      } else {
        enqueueSnackbar(t('error.unregister_vehicle'), {
          variant: 'error'
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    unregisterVehiclesFunction
  };
}